import { createContext, useCallback, useContext, useMemo, useState } from "react";
import Drawer from "@/components/drawer";

const DrawerContext = createContext(null);

export function DrawerProvider({ children }) {
  const [drawerState, setDrawerState] = useState({
    isOpen: false,
    title: "",
    content: null,
    footer: null,
    size: "sm",
  });

  const closeDrawer = useCallback(() => {
    setDrawerState((previous) => {
      if (typeof previous.onClose === "function") {
        previous.onClose();
      }

      return {
        isOpen: false,
        title: "",
        content: null,
        footer: null,
        size: "sm",
      };
    });
  }, []);

  const openDrawer = useCallback(({ title, content, footer = null, size = "sm", onClose = null }) => {
    setDrawerState({
      isOpen: true,
      title: title || "",
      content: content || null,
      footer,
      size: ["sm", "md", "lg"].includes(size) ? size : "sm",
      onClose,
    });
  }, []);

  const contextValue = useMemo(() => ({ openDrawer, closeDrawer }), [openDrawer, closeDrawer]);

  return (
    <DrawerContext.Provider value={contextValue}>
      {children}
      <Drawer
        isOpen={drawerState.isOpen}
        onClose={closeDrawer}
        title={drawerState.title}
        footer={drawerState.footer}
        size={drawerState.size}
      >
        {drawerState.content}
      </Drawer>
    </DrawerContext.Provider>
  );
}

export function useDrawer() {
  const context = useContext(DrawerContext);

  if (!context) {
    throw new Error("useDrawer must be used within DrawerProvider");
  }

  return context;
}
